import { Flex, Text } from "@nulogy/components";
import React from "react";

export default function ShiftHeader({ shiftInstance }) {
  const { maxLabor, startingLabor } = shiftInstance;

  return (
    <Flex flexDirection="column" flexWrap="wrap" justifyContent="flex-start">
      {/* biome-ignore lint/a11y/noLabelWithoutControl: I'm not sure what this label is for */}
      <label>
        <Text
          className="spec-shift-name"
          data-testid="shift-name"
          fontSize="smaller"
          fontWeight="medium"
          lineHeight="smallTextCompressed"
        >
          {shiftInstance.name}
        </Text>
        <Text
          className={`spec-shift-max-labor-${shiftInstance.shiftId}`}
          fontSize="smaller"
          lineHeight="smallTextCompressed"
        >
          Max labor: {maxLabor}
        </Text>
        <Text
          className={`spec-shift-starting-labor-${shiftInstance.shiftId}`}
          fontSize="smaller"
          lineHeight="smallTextCompressed"
        >
          Starting labor: {startingLabor}
        </Text>
      </label>
    </Flex>
  );
}
